import { Country } from '@models/CountriesAndLanguages';
import { Provider } from '@models/Provider';

import { createAdminApi, getApiBaseUrl } from '../shared/utils';

export type ProviderDTO = Pick<
  Provider,
  | 'allActiveContentId'
  | 'alwaysSubscribed'
  | 'country'
  | 'cvpId'
  | 'id'
  | 'image'
  | 'name'
  | 'params'
  | 'portalIds'
  | 'rowKey'
  | 'type'
>;

const api = createAdminApi(`${getApiBaseUrl('providers')}/admin`, { 'x-api-version': '1.0' });

export const fetchAllProviders = (country?: Country) =>
  api.get<Provider[]>('list', undefined, {
    headers: { ...(country ? { country } : {}) },
  });

export const upsertProvider = (provider: ProviderDTO) =>
  api.put<Provider>(provider.rowKey, provider);

export const deleteProvider = (rowKey: string) => api.delete(rowKey, rowKey);
